import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import { getRankList, setScroll } from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import styles from './WallPaperRank.module.less';

const selectWpRankList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.rankList,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function WPRank() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;
  const [pageContent, setPageContent] = useState(null);
  const rankList = useSelector(selectWpRankList);
  const logInfoData = useSelector(selectLogInfo);

  const code = getQueryString('code');
  const wallpaperId = getQueryString('wallpaperId');
  const [showNumber, setShowNumber] = useState(8);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_RankMore||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_RankMore',
        label: '',
        param2: {
          source: `Wallpaper_RankMore||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_RankMore||${code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  /**
   * 获取榜单图片
   */
  useEffect(() => {
    if (
      rankList.code !== code ||
      (rankList.list.length < rankList.pagenation.limit &&
        rankList.list.length < rankList.pagenation.count)
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          skip: 0,
          code,
          wallpaperId,
          refresh: true,
        }),
      );
    }
  }, []);

  const loadMore = useCallback(() => {
    if (
      rankList.load !== true &&
      rankList.code === code &&
      rankList.list.length < rankList.pagenation.count
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
        }),
      );
    }
  });

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(8);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(10);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(11);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(13);
    } else if (clientWidth >= 1870) {
      setShowNumber(16);
    }
  }, []);

  const getClassType = useCallback((index = 0, number = 8) => {
    const series = {
      '8': {
        small: [1, 6],
        small_space: [2, 3, 7, 0],
        big: [4],
        big_space: [5],
      },
      '10': {
        small: [1, 7],
        small_space: [2, 3, 4, 8, 9, 0],
        big: [5],
        big_space: [6],
      },
      '11': {
        small: [1, 8],
        small_space: [2, 3, 4, 9, 10, 0],
        big: [5],
        big_space: [6, 7],
      },
      '13': {
        small: [1, 9],
        small_space: [2, 3, 4, 5, 10, 11, 12, 0],
        big: [6],
        big_space: [7, 8],
      },
      '16': {
        small: [1, 11],
        small_space: [2, 3, 4, 5, 6, 12, 13, 14, 15, 0],
        big: [7],
        big_space: [8, 9, 10],
      },
    };
    const pos = (index + 1) % parseInt(number);
    let classType = 'small';
    if (series[number].small.indexOf(pos) > -1) {
      classType = 'small';
    }
    if (series[number].small_space.indexOf(pos) > -1) {
      classType = 'small_space';
    }
    if (series[number].big.indexOf(pos) > -1) {
      classType = 'big';
    }
    if (series[number].big_space.indexOf(pos) > -1) {
      classType = 'big_space';
    }
    return classType;
  }, []);

  if (rankList.list.length === 0 && rankList.load) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  if (rankList.list.length === 0 && rankList.load === false) {
    return <Blank load={rankList.load} />;
  }
  return (
    <div className={styles.page} ref={r => setPageContent(r)}>
      <div className={styles.page_container}>
        {rankList.name && <div className={styles.rank_name}>{rankList.name}</div>}
        {rankList.desc && <div className={styles.rank_desc}>{rankList.desc}</div>}
        {code === rankList.code && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={rankList.list.length < rankList.pagenation.count}
            loader={
              <div className="loader" key={0}>
                ----------加载中----------
              </div>
            }
            initialLoad={false}
            useWindow={false}
            getScrollParent={() => pageContent}
          >
            <div className={styles.showreel}>
              {rankList.list.map((item, index) => {
                return (
                  <WallpaperCard
                    wallpaper={item}
                    key={index}
                    cardInfo={{
                      pageSource: 'rank',
                      code,
                      classType: getClassType(index, showNumber),
                      isCollect: true,
                      isWallpaper: true,
                      isDeleteColl: false,
                      isDeleteUsed: false,
                      isPreview: true,
                    }}
                    logInfo={{ source: `Wallpaper_RankMore||${code}` }}
                  />
                );
              })}
              {rankList.list.length >= rankList.pagenation.count && rankList.pagenation.count > 5 && (
                <div className="loader" style={{ width: '800px' }}>
                  ----------到底啦----------
                </div>
              )}
            </div>
          </InfiniteScroll>
        )}
        <ScrollTop node={pageContent} />
      </div>
    </div>
  );
}
// });

export default porps => {
  const history = useHistory();
  const { refresh } = useAliveController();
  const code = getQueryString('code');

  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh(`wprank_${code}`);
    }
  }, []);
  return (
    <KeepAlive name={`wprank_${code}`}>
      <WPRank />
    </KeepAlive>
  );
};

// export default () => {
//   return (
//     <KeepAlive name={`wprank_${code}`} id={code}>
//       <WPRank></WPRank>
//     </KeepAlive>
//   );
// };
